import { render, staticRenderFns } from "./SelectStatus.vue?vue&type=template&id=1521f2c2"
import script from "./SelectStatus.vue?vue&type=script&lang=js"
export * from "./SelectStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports